import { useState, useEffect } from 'react';

/**
 * useScrolled
 * Returns true once the page has been scrolled past `threshold` pixels.
 * Cleans up the scroll listener on unmount.
 */
export default function useScrolled(threshold = 30) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrolled;
}
